/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";

import { StaticPageContentService, IStaticPageContentMethods, PortfolioFormService, IPortfolioFormMethods, IUpdatePortfolioStatusMethods, UpdatePortfolioStatusService, IShowcasePortfolioMethods, ShowcasePortfolioService,IEditPortfolioMethods, EditPortfolioService  } from "./components";

export type ReviewPortfolioPageAgent = IStaticPageContentMethods &
  IPortfolioFormMethods &
  IUpdatePortfolioStatusMethods &
  IShowcasePortfolioMethods &
  IPortfolioFormMethods &
  IEditPortfolioMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new PortfolioFormService(),
    new UpdatePortfolioStatusService(),
    new ShowcasePortfolioService(),
    new EditPortfolioService(),
  ]
}

export const getAgent = () => {
  return createAgent<ReviewPortfolioPageAgent>({
    plugins: getPlugins(),
  });
};